import React from 'react';
import ic from '../images/ic.svg';
import AES128 from './AES128';

export default class Receipt extends React.PureComponent {

    render() {
      
      const {data} = this.props;
      return (
        <div style={{width: '400px', fontSize: '20px'}} className='text-center p-1' dir='rtl'>
            <h2>رسید ثبت نام</h2>
            <div className='d-flex justify-content-between'>
                <div className='my-auto'>
                    <h3>آموزشگاه موسیقی شمشال</h3>
                    <span>تلفن : 02636201613</span>
                </div>
                <img src={ic} width={120} height={120} alt='logo' />
            </div>
            <hr />
            <div className='text-right'>
                <div><span>{"نام هنرجو : "+data['name']}</span></div>
                <div><span>{"شماره هنرجو : *******"+data['phone'].slice(7)}</span></div>
                <div><span>{"کد ملی : ******"+data['code_meli'].slice(6)}</span></div>
                <div><span>{"نام استاد : "+data['mastername']}</span></div>
                <div><span>{"کلاس : "+data['classname']}</span></div>
                <div><span>{"ساعت : "+data['time']}</span></div>
                <div><span>{"دوره : "+data['jalase']+" جلسه ای"}</span></div>
                <div><span>{"تاریخ ثبت نام : "+data['createdate']}</span></div>
                <div><span>{"شهریه کل : "+AES128.formatMoney(data['price'])+" تومان"}</span></div>
                <div><span>{"تخفیف : "+AES128.formatMoney(data['offprice'])+" تومان"}</span></div>
                {data['offtext']!=""?<div><span>{"کد تخفیف : "+data['offtext']}</span></div>:null}
                <div><span>{"پرداختی : "+AES128.formatMoney(data['endprice'])+" تومان"}</span></div>
                <div><span>{"کد پیگیری : "+data['hash']}</span></div>
            </div>
        </div>
      );
    }
  }